import React, { FC } from 'react';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { Filter as FilterType } from 'src/types/filter';
import { FilterOption } from 'src/types/filterOption';
import DropdownFilterMenu from './DropdownFilterMenu';

interface Props {
  filters: FilterType[];
  selectedFilters: { [field: string]: FilterOption[] };
  onSelectedFiltersChange: (newState: { [field: string]: FilterOption[] }) => void;
  onFilterUpdated: (filterDescriptors: CompositeFilterDescriptor[], field: string) => void;
  onDropdownAutocompleteChange?: (value: string) => void;
  filterLogic: 'contains' | 'excludes';
}

const DropdownFilter: FC<Props> = ({ filters, selectedFilters, onSelectedFiltersChange, onFilterUpdated, onDropdownAutocompleteChange, filterLogic }) => {
  const buildCompositeFilterDescriptor = (filtersObj: { [field: string]: FilterOption[] }): CompositeFilterDescriptor[] => {
    return Object.entries(filtersObj)
      .filter(([, options]) => options.length > 0)
      .map(([field, options]) => ({
        logic: filterLogic === 'contains' ? 'or' : 'and',
        filters: options.map((option) => ({
          field,
          value: option.value ?? option.name,
          operator: filterLogic === 'contains' ? 'eq' : 'ne',
        })),
      })) as CompositeFilterDescriptor[];
  };

  const handleEmitFilter = (field: string, options: FilterOption[]) => {
    // 1. Update the parent’s selectedFilters
    const newSelected = { ...selectedFilters, [field]: options };
    onSelectedFiltersChange(newSelected);

    // 2. Rebuild the entire composite from newSelected
    const newDescriptor = buildCompositeFilterDescriptor(newSelected);

    // 3. Pass the complete array to onFilterUpdated
    onFilterUpdated(newDescriptor, field);
  };

  return (
    <div className="dropdown-filter-menu-container">
      {filters.map((filter) => (
        <DropdownFilterMenu
          key={filter.field}
          filter={filter}
          label={filter.title}
          selectedOptions={selectedFilters[filter.field] || []}
          onAutocompleteChange={(e, value) => onDropdownAutocompleteChange?.(value)}
          emitFilterData={(options: FilterOption[]) => handleEmitFilter(filter.field, options)}
        />
      ))}
    </div>
  );
};

export default DropdownFilter;
